import { Variant } from "@/types/index";
import store from "../store/store";

/**
 * Validates if two variants have valid skipass durations.
 * @param {Variant} variant1 - The first variant to check.
 * @param {Variant} variant2 - The second variant to check.
 * @returns {boolean} True if both variants have valid skipass durations and are different, false otherwise.
 */
const isValidSkipassDuration = (variant1: Variant, variant2: Variant): boolean => {
  const validSkipassesDuration = [6, 7];
  return (
    validSkipassesDuration.includes(variant1.skipass) &&
    validSkipassesDuration.includes(variant2.skipass) &&
    variant1.skipass !== variant2.skipass
  );
};

/**
 * Validates if at least one variant has a valid code package.
 * @param {Variant} variant1 - The first variant to check.
 * @param {Variant} variant2 - The second variant to check.
 * @returns {boolean} True if at least one variant has a valid code package, false otherwise.
 */
const hasValidCodePackage = (variant1: Variant, variant2: Variant): boolean => {
  const validCodePackages: Set<string> = new Set(["PF", "PFP"]);
  return (
    validCodePackages.has(variant1.codePackage) ||
    validCodePackages.has(variant2.codePackage)
  );
};

/**
 * Determines if the combination of two variants is a valid New SkiPass duration combo (PF_7 with PF_6 OR PFP_7 with PFP_6) and the locale is NL.
 * @param {Variant[]} variants - An array of n variants to check.
 * @returns {boolean} True if the variants form a valid ski pass duration combo and the locale is NL, false otherwise.
 */
export const isValidNewSkiPassPackages = (variants: Variant[]): boolean => {
  if (!variants || variants.length < 2) return false;

  for (let i = 0; i < variants.length; i++) {
    for (let j = i + 1; j < variants.length; j++) {
      if (
        isValidSkipassDuration(variants[i], variants[j]) &&
        hasValidCodePackage(variants[i], variants[j]) &&
        store.getters.isLocaleNL
      ) {
        return true;
      }
    }
  }

  return false;
};